import { ColumnData } from 'common/components/SearchBar';
import { commonColumnProps } from 'common/utils/columnUtilities';

export const columns: ColumnData[] = [
  {
    key: 'cardHolder',
    name: 'Card Holder',
    fieldName: 'cardHolder',
    minWidth: 200,
    maxWidth: 300,
    ...commonColumnProps,
  },
  {
    key: 'cardNumber',
    name: 'Number',
    fieldName: 'cardNumber',
    minWidth: 200,
    maxWidth: 300,
    ...commonColumnProps,
  },
  {
    key: 'cardExpiry',
    name: 'Expiry',
    fieldName: 'cardExpiry',
    minWidth: 150,
    maxWidth: 200,
    ...commonColumnProps,
  },
  {
    key: 'department',
    name: 'Department',
    fieldName: 'department',
    minWidth: 150,
    maxWidth: 250,
    ...commonColumnProps,
  },
  {
    key: 'documentFolder',
    name: 'Document Folder',
    fieldName: 'documentFolder',
    minWidth: 150,
    maxWidth: 250,
    ...commonColumnProps,
  },
  {
    key: 'cardStatus',
    name: 'Status',
    fieldName: 'cardStatus',
    minWidth: 150,
    maxWidth: 230,
    ...commonColumnProps,
  },
];
